import React from 'react';
import HomeHero from '../HomeHero/HomeHero';
import TradeTiles from '../TradeTiles/TradeTiles';
import HowItWorks from '../HowItWorks/HowItWorks';
import ProBand from '../ProBand/ProBand';
import SEO from '../common/SEO/SEO';
import { BandTitle, TradeTilesBand } from './RefinedLandingPage.styled';

const RefinedLandingPage = () => {
  return (
    <>
      <SEO
        title="NKY Connect"
        description="Find trusted plumbing, HVAC, electrical, and landscaping pros in Northern Kentucky. NKY Connect matches you with local service providers."
        path="/"
      />
      <HomeHero />
      <TradeTilesBand>
        <BandTitle>Or start with a service</BandTitle>
        <TradeTiles variant="icon" />
      </TradeTilesBand>
      <HowItWorks />
      <ProBand />
    </>
  );
};

export default RefinedLandingPage;
